module.exports = __webpack_public_path__ + "img/ctrl-st-stub-up-+i.93a1d510.svg";